import { render, staticRenderFns } from "./tnc-uz.vue?vue&type=template&id=d5215b0c&scoped=true"
import script from "./tnc-uz.vue?vue&type=script&lang=js"
export * from "./tnc-uz.vue?vue&type=script&lang=js"
import style0 from "./tnc-uz.vue?vue&type=style&index=0&id=d5215b0c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5215b0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5215b0c')) {
      api.createRecord('d5215b0c', component.options)
    } else {
      api.reload('d5215b0c', component.options)
    }
    module.hot.accept("./tnc-uz.vue?vue&type=template&id=d5215b0c&scoped=true", function () {
      api.rerender('d5215b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/tnc/tnc-uz.vue"
export default component.exports